import {
    IWorkbenchInjectable,
} from '@src/slide/application/service/workbench-service/inject/worbench-injectable.interface';
import { LoaderType } from '@src/slide/application/service/workbench-service/core/workbench-service.interface';

export default class TocPcWorkbenchInjectable implements IWorkbenchInjectable {
    public async getWorkbenchLoader(): Promise<LoaderType<any>> {
        const module = await import('@framework/workbench/loader/toc/toc-pc-loader');
        return module.default;
    }
}
